import { useMsal } from '@azure/msal-react';
import { useEffect } from 'react';
import { useDispatch } from 'react-redux'
// import { setCurrentUser } from './utenteCorrenteSlice'
import { setPartnerMenu, setAziendaMenu } from './siteMapsSlice'

import { setCurrentUserByToken } from 'features-csvc/reduxStore/utenteCorrenteSlice';

function decodeJwt(token) {
    const base64Url = token.split('.')[1];
    const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
    const jsonPayload = decodeURIComponent(window.atob(base64).split('').map(c => {
        return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
    }).join(''));
    return JSON.parse(jsonPayload);
}  

export const SetUpCurrentUserInRedux = () => {
    const dispatch = useDispatch();
    const { instance } = useMsal();
    if (instance) {
        const activeAccount = instance.getActiveAccount();

        // INDICATIVAMENTE QUI DOVRO' allineare il contenuto dello slice 
        // utenteCorrente con il contenuto del documento mongo  utenti.
        // state.csvcUuid = ad es.: "csvcUuid": "b3231a39-5539-4a8a-8750-29bfab458f27"
        // state.emailUsername = ...

        // console.log ("SONO IN SetUpCurrentUserInRedux e ho letto il seguente token: ", activeAccount.idToken)


        // 2025-03-09 - START - Sostituito chiamata seguente con la successiva
        // dispatch(setCurrentUser(activeAccount.idToken))

        useEffect( () => {
            dispatch( setCurrentUserByToken (activeAccount.idToken))
        }, [])
        // 2025-03-09 - END 


        // Inoltre se csvcRole = "partner" devo aggiungere il capitolo di menù:
        //      ->  pannelloDiControllo

        const decodedPayload = decodeJwt(activeAccount.idToken)
        const csvcRole = decodedPayload.jobTitle
        switch (csvcRole) {
            case 'partner':
                dispatch(setPartnerMenu())
                // dispatch(unsetCapitoloMenu('xxxx'))
                break
            case 'azienda':
                dispatch(setAziendaMenu())
                // dispatch(unsetCapitoloMenu('xxxx'))
                break
            default:
                dispatch(setPartnerMenu())
        }
    }


    return null
};
